import { SLIDE_LIST } from './maps';

export const ANIMATION_DEFAULT_DELAY = 0.5;
export const BOOTSTRAP_LARGE_SCREEN_MIN = 992;
export const MAX_SLIDE_NUMBER = SLIDE_LIST.length;
